import { RichTextBlock } from 'prismic-reactjs';
import gql from 'graphql-tag';
import { IImage, ILink } from 'utils/types';
import { IBaseSlice, SliceTypes } from '.';
import { fetchInvestorInformations, parseInvestorInformations } from '../investorInformation';
import { parseRichText, parseString } from '../utils/parsers';

export interface IQuarters extends IBaseSlice {
  tagline: string;
  title: string;
  items: Array<{
    title: string;
    quarters: Array<{
      quarter: string;
      consolidated: ILink;
      press: ILink;
      earnings: ILink;
      webcast: ILink;
    }>;
  }>;
}

export const fragment = (name: string, type: string, fragmentName: string) => gql`
  fragment ${fragmentName || name} on ${type} {
    ... on ${type}${name} {
      type
      primary {
        slice_tagline
        slice_title
      }
    }
  }
`;

type NestedProps = {
  lang: string;
  limit?: number;
  previewData: boolean;
  redirects: Array<{ from: string; to: string }>;
};

export const fetchInvestorInformationsAndParse = async ({
  lang,
  limit,
  previewData,
  redirects = [],
}: NestedProps) => {
  const items = await fetchInvestorInformations(lang, '', previewData, (limit = 500));
  return parseInvestorInformations(items, redirects);
};

type Props = {
  primary: {
    slice_tagline: RichTextBlock[];
    slice_title: RichTextBlock[];
  };
};

export const parse = (slice: Props, redirects?): IQuarters => ({
  type: SliceTypes.Quarters,
  tagline: parseString(slice.primary.slice_tagline),
  title: parseString(slice.primary.slice_title),
  items: [],
});
